(function(){
'use strict';
var host=document.querySelector('[data-mmpk]'),fig=document.querySelector('[data-mmpk-preview]');
if(!host||!fig)return;
var svg=fig.querySelector('[data-mmpk-svg]'),DARK=/^(weiss|silber|edelstahl)$/;
var MOB=window.matchMedia?window.matchMedia('(max-width: 749px)'):null;
var REDUCE=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function all(s,el){return Array.prototype.slice.call((el||document).querySelectorAll(s));}
function set(el,a,v){if(el&&el.getAttribute(a)!==v)el.setAttribute(a,v);}
function fire(i){i.dispatchEvent(new Event('input',{bubbles:true}));i.dispatchEvent(new Event('change',{bubbles:true}));}
/* Hintergrund passend zur Farbe: helle Farben auf dunklem Grund */
function shade(){fig.classList.toggle('is-dark',DARK.test(fig.getAttribute('data-fin')||''));}
new MutationObserver(shade).observe(fig,{attributes:true,attributeFilter:['data-fin']});shade();
/* Edelstahl: polierter Glanz mit hellen und dunklen Reflexbaendern wie beim Original */
(function(){
var NS='http://www.w3.org/2000/svg',defs=svg.querySelector('defs'),g=svg.querySelector('#mmpk-f-edelstahl'),u=svg.querySelector('.mmpk-use');
if(!defs||!g||!u||!/^(hund|katze)$/.test(fig.getAttribute('data-tier')||''))return;
function stops(el,list,op){el.textContent='';list.forEach(function(s){var e=document.createElementNS(NS,'stop');e.setAttribute('offset',s[0]);e.setAttribute('stop-color',op?'#fff':s[1]);if(op)e.setAttribute('stop-opacity',s[1]);el.appendChild(e);});}
['x1:170','y1:60','x2:860','y2:330','spreadMethod:reflect'].forEach(function(a){a=a.split(':');g.setAttribute(a[0],a[1]);});
stops(g,[[0,'#c9cdd0'],[.07,'#f7f8f9'],[.15,'#a4aaae'],[.25,'#6a7075'],[.34,'#aeb4b8'],[.43,'#eef0f1'],[.5,'#fcfcfd'],[.58,'#b4babe'],[.68,'#777d82'],[.78,'#c2c6c9'],[.88,'#f0f1f2'],[1,'#8f959a']]);
var sg=document.createElementNS(NS,'linearGradient');sg.id='mmpk-sheen';
['gradientUnits:userSpaceOnUse','x1:200','y1:60','x2:820','y2:700'].forEach(function(a){a=a.split(':');sg.setAttribute(a[0],a[1]);});
stops(sg,[[0,0],[.36,0],[.46,.55],[.52,0],[.7,0],[.8,.35],[.86,0],[1,0]],1);
defs.appendChild(sg);
var c=u.cloneNode(true);c.setAttribute('fill','url(#mmpk-sheen)');c.setAttribute('class','mmpk-sheen');c.setAttribute('pointer-events','none');c.style.display='none';u.parentNode.insertBefore(c,u.nextSibling);
function sheen(){c.style.display=(fig.getAttribute('data-fin')==='edelstahl')?'':'none';}
new MutationObserver(sheen).observe(fig,{attributes:true,attributeFilter:['data-fin']});sheen();
})();
/* Namensschild: Name optisch mittig, Motive direkt daneben, wie beim Original */
var cv=document.createElement('canvas'),cx=cv.getContext&&cv.getContext('2d');
function plate(){
var p=svg.querySelector('[data-mmpk-schild]'),t=svg.querySelector('[data-mmpk-name]');
if(!p||!t||!cx||!cx.measureText)return;
var px=+p.getAttribute('x'),pw=+p.getAttribute('width'),py=+p.getAttribute('y'),ph=+p.getAttribute('height');
var gl=svg.querySelector('[data-mmpk-motif="links"]'),gr=svg.querySelector('[data-mmpk-motif="rechts"]');
var hl=!!(gl&&gl.firstElementChild),hr=!!(gr&&gr.firstElementChild);
var name=t.textContent||'',fam=t.style.fontFamily||'Georgia, serif';
cx.font='100px '+fam;
var m=cx.measureText(name),capH=cx.measureText('H').actualBoundingBoxAscent;
if(!capH||!m.width)return;
var asc=m.actualBoundingBoxAscent||capH,desc=m.actualBoundingBoxDescent||0;
var bl=m.actualBoundingBoxLeft||0,br=m.actualBoundingBoxRight||m.width,ink=Math.max(1,bl+br);
var ms=ph*.62,gap=ph*.4,side=(hl?ms+gap:0)+(hr?ms+gap:0);
var k=Math.min(ph*.5/capH,(pw-ph*1.1-side)/ink);
if((asc+desc)*k>ph*.84)k=ph*.84/(asc+desc);
var cy=py+ph/2,base=cy+capH*k/2;
if(base+desc*k>py+ph*.92)base=py+ph*.92-desc*k;
if(base-asc*k<py+ph*.08)base=py+ph*.08+asc*k;
var tw=ink*k,gx=px+pw/2-(tw+side)/2,il=gx+(hl?ms+gap:0);
set(t,'text-anchor','middle');set(t,'dominant-baseline','alphabetic');
set(t,'x',(il+bl*k+m.width*k/2).toFixed(1));set(t,'y',base.toFixed(1));set(t,'font-size',(100*k).toFixed(2));
var gy=(cy-ms/2).toFixed(1),sc=(ms/100).toFixed(4);
if(gl)set(gl,'transform','translate('+gx.toFixed(1)+' '+gy+') scale('+sc+')');
if(gr)set(gr,'transform','translate('+(il+tw+gap).toFixed(1)+' '+gy+') scale('+sc+')');
}
/* Größen-Kacheln: kleine Silhouetten statt Quadrate */
function pics(){all('.mmpk-size__pic').forEach(function(p){
if(p.querySelector('svg'))return;
var i=p.querySelector('i'),s=i?parseFloat(i.style.getPropertyValue('--s'))||1:1,w=100*s;
p.insertAdjacentHTML('beforeend','<svg viewBox="0 0 100 100" aria-hidden="true" focusable="false"><use href="#mmpk-art" x="'+(50-w/2)+'" y="'+(100-w)+'" width="'+w+'" height="'+w+'"/></svg>');
});}
/* Farben in ruhiger Reihenfolge */
function colors(){var h=document.querySelector('[data-mmpk-colors]');if(!h||h.getAttribute('data-ord'))return;
var o=['schwarz','anthrazit','glimmer','silber','weiss','rost'],b=all('.mmpk-color',h);if(!b.length)return;
b.sort(function(x,y){var a=x.querySelector('.mmpk-sw'),c=y.querySelector('.mmpk-sw');return o.indexOf(a&&a.getAttribute('data-f'))-o.indexOf(c&&c.getAttribute('data-f'));});
b.forEach(function(x){h.appendChild(x);});h.setAttribute('data-ord','1');}
/* Motive: einmal wählen, gilt links und rechts; eigener Wunsch auf Knopfdruck */
function firstText(el){var w=document.createTreeWalker(el,NodeFilter.SHOW_TEXT,null),n;while((n=w.nextNode()))if(n.nodeValue.trim())return n;return null;}
function own(inp,g){
var wrap=inp.closest('.tpo_option-input-wrapper');if(!wrap||g.querySelector('.mmpk-motif--own'))return;
var known=all('.mmpk-motif',g).map(function(b){return(b.getAttribute('data-m')||'').toLowerCase();});
var b=document.createElement('button');b.type='button';b.className='mmpk-motif mmpk-motif--own';b.setAttribute('data-m','Eigener Wunsch');
b.innerHTML='<svg viewBox="0 0 100 100" aria-hidden="true"><path d="M22 78l6-22 40-40 16 16-40 40zM60 24l16 16" fill="none" stroke="currentColor" stroke-width="8" stroke-linejoin="round"/></svg><span>Eigener Wunsch</span>';
g.appendChild(b);
function custom(){var v=(inp.value||'').trim().toLowerCase();return !!v&&known.indexOf(v)<0;}
function upd(open){wrap.classList.toggle('mmpk-own-hide',!(open||custom()));b.classList.toggle('is-own',custom());}
b.addEventListener('click',function(){upd(true);if(!custom()&&inp.value){inp.value='';fire(inp);}try{inp.focus();}catch(e){}});
inp.addEventListener('input',function(){upd(true);});
g.addEventListener('click',function(e){var x=e.target.closest('.mmpk-motif');if(x&&x!==b)upd(false);});
upd(false);
}
function motifs(){
var L,R;all('.tpo_option-container[data-mmpk-kind="motif"]').forEach(function(c){var i=c.querySelector('input[name^="properties[Motiv"]');if(!i)return;if(/rechts/i.test(i.name))R=c;else L=c;});
if(!L||!R||L.getAttribute('data-pair'))return;
var li=L.querySelector('input[name^="properties[Motiv"]'),ri=R.querySelector('input[name^="properties[Motiv"]');
var gL=L.querySelector('.mmpk-motifs'),gR=R.querySelector('.mmpk-motifs');if(!gL||!gR)return;
L.setAttribute('data-pair','1');
var lab=L.querySelector('.form__label'),txt=lab&&firstText(lab),linked=!(ri.value&&ri.value!==li.value);
var row=document.createElement('label');row.className='mmpk-pair';row.innerHTML='<input type="checkbox"><span>Links und rechts verschiedene Motive</span>';
var cb=row.querySelector('input'),wl=li.closest('.tpo_option-input-wrapper')||li;wl.parentNode.insertBefore(row,wl.nextSibling);
function copy(){if(ri.value!==li.value){ri.value=li.value;fire(ri);}}
function apply(){cb.checked=!linked;R.classList.toggle('mmpk-pair-off',linked);if(txt)txt.nodeValue=linked?'Motiv links und rechts vom Namen':'Motiv links neben dem Namen';}
cb.addEventListener('change',function(){linked=!cb.checked;if(linked)copy();apply();});
gL.addEventListener('click',function(e){if(linked&&e.target.closest('.mmpk-motif'))setTimeout(copy,0);});
li.addEventListener('input',function(){if(linked)copy();});
apply();own(li,gL);own(ri,gR);
}
/* Handy: nach dem Schrittwechsel steht die Überschrift direkt unter der Vorschau */
function stepNow(){var f=fig.closest('form');return f?f.getAttribute('data-mmpk-step'):'';}
function sizeStep(){fig.classList.toggle('is-size',stepNow()==='2');}
document.addEventListener('click',function(e){
var b=e.target.closest&&e.target.closest('[data-mmpk-next],[data-mmpk-back],[data-goto]');
if(!b||!MOB||!MOB.matches||!fig.closest('form'))return;
var before=stepNow();
setTimeout(function(){
if(stepNow()===before)return;
var p=document.querySelector('.mmpk-panel:not([hidden])'),h=document.querySelector('.mmpp-h.is-open')||(p&&(p.querySelector('.mmpk-h')||p));if(!h)return;
var hh=parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'))||0;
var y=window.pageYOffset+h.getBoundingClientRect().top-fig.getBoundingClientRect().height-hh-14;
/* Kopfzeile erscheint nur beim Hochscrollen: beim Runterscrollen ohne sie rechnen */
if(y>=window.pageYOffset)y+=hh;
window.scrollTo({top:Math.max(0,y),behavior:REDUCE?'auto':'smooth'});
},60);
},true);
/* Handy: beim Tippen wird die Vorschau kompakter, damit Eingabefeld und Tastatur Platz haben */
function isTxt(t){return !!t&&/^(INPUT|TEXTAREA)$/.test(t.tagName)&&!/^(radio|checkbox|button|submit|file|hidden)$/.test(t.type||'');}
document.addEventListener('focusin',function(e){var t=e.target;if(MOB&&MOB.matches&&isTxt(t)&&t.closest('form')===fig.closest('form'))fig.classList.add('is-typing');});
document.addEventListener('focusout',function(){setTimeout(function(){if(!isTxt(document.activeElement))fig.classList.remove('is-typing');},150);});
/* Vergrößern */
function zoom(){
var lb=document.createElement('div');lb.className='mmpk-lb'+(fig.classList.contains('is-dark')?' is-dark':'');
lb.setAttribute('role','dialog');lb.setAttribute('aria-modal','true');lb.setAttribute('aria-label','Vorschau vergrößert');
var c=svg.cloneNode(true),d=c.querySelector('defs');if(d)d.parentNode.removeChild(d);
all('[data-mmpk-measure]',c).forEach(function(n){n.parentNode.removeChild(n);});
all('*',c).concat([c]).forEach(function(n){Array.prototype.slice.call(n.attributes).forEach(function(a){if(a.name.indexOf('data-mmpk')===0)n.removeAttribute(a.name);});});
c.setAttribute('class','mmpk-lb__svg');lb.appendChild(c);
lb.insertAdjacentHTML('beforeend','<button type="button" class="mmpk-lb__x" aria-label="Schließen">×</button>');
var btn=fig.querySelector('[data-mmpk-zoom]');
function close(){document.removeEventListener('keydown',key);if(lb.parentNode)lb.parentNode.removeChild(lb);document.documentElement.classList.remove('mmpk-lock');try{btn.focus({preventScroll:true});}catch(e){}}
function key(e){if(e.key==='Escape')close();}
lb.addEventListener('click',close);document.addEventListener('keydown',key);
document.body.appendChild(lb);document.documentElement.classList.add('mmpk-lock');
try{lb.querySelector('.mmpk-lb__x').focus({preventScroll:true});}catch(e){}
}
fig.querySelector('[data-mmpk-zoom]').addEventListener('click',zoom);
svg.addEventListener('click',zoom);
/* Start, sobald der Konfigurator aufgebaut ist */
function init(){
pics();colors();motifs();
var fm=fig.closest('form');if(fm){new MutationObserver(sizeStep).observe(fm,{attributes:true,attributeFilter:['data-mmpk-step']});}sizeStep();
var t=svg.querySelector('[data-mmpk-name]'),mo=new MutationObserver(plate);
mo.observe(t,{attributes:true,childList:true,characterData:true,subtree:true});
all('[data-mmpk-motif]',svg).forEach(function(g){mo.observe(g,{attributes:true,attributeFilter:['transform'],childList:true});});
plate();
if(document.fonts){if(document.fonts.addEventListener)document.fonts.addEventListener('loadingdone',plate);if(document.fonts.ready)document.fonts.ready.then(plate);}
}
var n=0;(function wait(){if(host.getAttribute('data-ready')==='1'){try{init();}catch(e){}return;}if(++n<150)setTimeout(wait,200);})();
})();

/* r4: Handy – nach Texteingabe (Name) und Schritt-Wechsel die Vorschau sauber ausrichten,
   erst wenn die Tastatur zu ist. Bild oben komplett sichtbar, Überschrift direkt darunter. */
(function () {
  'use strict';
  var MQ = window.matchMedia ? matchMedia('(max-width: 749px)') : null;
  var typedAt = 0;
  function mob() { return MQ && MQ.matches; }
  function isTxt(el) { return el && (el.tagName === 'TEXTAREA' || (el.tagName === 'INPUT' && !/^(file|radio|checkbox|button|submit)$/i.test(el.type))); }
  document.addEventListener('pointerdown', function (e) {
    var b = e.target.closest && e.target.closest('[data-mmpk-next],[data-mmpk-back],[data-goto]');
    if (!b || !mob()) return;
    var a = document.activeElement;
    if (isTxt(a)) {
      typedAt = Date.now();
      try { a.blur(); } catch (x) {}
      var f = document.querySelector('.mmpk-preview');
      if (f) f.classList.remove('is-typing');
    }
  }, true);
  function align() {
    var f = document.querySelector('.mmpk-preview');
    var p = document.querySelector('.mmpk-panel:not([hidden])');
    var h = document.querySelector('.mmpp-h.is-open') || (p && (p.querySelector('.mmpk-h') || p));
    if (!f || !h || isTxt(document.activeElement)) return;
    var top = parseFloat(getComputedStyle(f).top) || 0;
    var want = top + f.getBoundingClientRect().height + 14;
    var d = h.getBoundingClientRect().top - want;
    if (Math.abs(d) < 8) return;
    var ry = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, window.pageYOffset + d), behavior: ry ? 'auto' : 'smooth' });
  }
  document.addEventListener('mmpk:step', function () {
    if (!mob() || Date.now() - typedAt > 1500) return;
    var t; setTimeout(align, 380); setTimeout(align, 900);
    var vv = window.visualViewport;
    if (vv) {
      var on = function () { clearTimeout(t); t = setTimeout(align, 140); };
      vv.addEventListener('resize', on);
      setTimeout(function () { vv.removeEventListener('resize', on); }, 1600);
    }
  });
})();

/* r5: Handy – beim Tippen bleibt das Eingabefeld direkt unter dem Bild sichtbar.
   Das Bild wird nur so weit verkleinert, wie es neben der Tastatur nötig ist; die Kopfzeile bleibt solange weg. */
(function () {
  'use strict';
  var fig = document.querySelector('[data-mmpk-preview]');
  if (!fig || !window.matchMedia) return;
  var MQ = matchMedia('(max-width: 749px)');
  var svg = fig.querySelector('[data-mmpk-svg]');
  var cur = null, tm = [], hdr = null;
  function isTxt(el) { return !!el && (el.tagName === 'TEXTAREA' || (el.tagName === 'INPUT' && !/^(file|radio|checkbox|button|submit|hidden)$/i.test(el.type || ''))); }
  function mine(el) { var f = fig.closest('form'); return !!(f && el.closest && el.closest('form') === f); }
  function header() { return hdr || (hdr = document.querySelector('.section-header.shopify-section-header-sticky, .shopify-section-header-sticky')); }
  function clear() { tm.forEach(clearTimeout); tm = []; }
  function fit() {
    if (!cur || document.activeElement !== cur || !MQ.matches || !svg) return;
    var vv = window.visualViewport, vh = vv ? vv.height : window.innerHeight;
    var box = cur.closest('.mmpkx-hello, .tpo_option-container') || cur;
    var need = cur.getBoundingClientRect().bottom - box.getBoundingClientRect().top + 14;
    var full = Math.min(window.innerHeight * 0.46, 440);
    var h = Math.max(150, Math.min(full, vh - need - 10));
    svg.style.height = Math.round(h) + 'px';
    /* Bild klebt oben (top 0): Eingabe-Block direkt darunter */
    var d = box.getBoundingClientRect().top - (fig.getBoundingClientRect().height + 8);
    if (Math.abs(d) > 6) window.scrollBy(0, d);
  }
  function soon() { clear(); [60, 250, 500, 900].forEach(function (ms) { tm.push(setTimeout(fit, ms)); }); }
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (!MQ.matches || !isTxt(t) || !mine(t)) return;
    cur = t;
    var h = header(); if (h) h.style.top = 'calc(-1 * var(--header-height, 0px) - 2px)';
    fig.style.top = '0px';
    soon();
  });
  document.addEventListener('focusout', function () {
    setTimeout(function () {
      if (isTxt(document.activeElement) && mine(document.activeElement)) return;
      cur = null; clear();
      if (svg) svg.style.height = '';
      fig.style.top = '';
      var h = header(); if (h) h.style.top = '';
    }, 160);
  });
  if (window.visualViewport) {
    var rt = 0;
    window.visualViewport.addEventListener('resize', function () { if (!cur) return; clearTimeout(rt); rt = setTimeout(fit, 120); });
  }
})();

/* Porsche-Aufbau (mmp-konfigurator-p.css/.js) mitladen; Version hochzählen, wenn sich die Dateien ändern */
(function () {
  var cs = document.currentScript;
  if (!cs || !cs.src || document.querySelector('[data-mmpp-load]')) return;
  var base = cs.src.split('mmp-konfigurator-v4.js')[0], V = '?v=p8';
  var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = base + 'mmp-konfigurator-p.css' + V; l.setAttribute('data-mmpp-load', '');
  document.head.appendChild(l);
  var s = document.createElement('script'); s.src = base + 'mmp-konfigurator-p.js' + V; s.async = false;
  document.body.appendChild(s);
})();
